import { RetailerEntity } from 'src/modules/retailer';

export enum BrandSpacesDetailsActions {
  FetchDetailsBegin = 'BRAND_SPACES/DETAILS/FETCH/BEGIN',
  FetchDetailsSuccess = 'BRAND_SPACES/DETAILS/FETCH/SUCCESS',
  FetchDetailsError = 'BRAND_SPACES/DETAILS/FETCH/ERROR',
}

export interface BrandSpacesDetailsStore {
  isLoading: boolean;
  isLoaded: boolean;
  error: any;
  brandSpace: RetailerEntity;
}
